import $ from 'jquery';
import { register } from '../../core/bootstrapper';
import AddToCart from '../../components/addToCart/addToCart';
import PasswordQualityView from '../../layout/PasswordQualityView';
import MainView from '../../pages/myAccount/profile/MainView';
import OrderListView from '../../pages/myAccount/orders/OrderListView';
import PreventionModel from '../../pages/myAccount/prevention/PreventionModel';
import PreventionView from '../../pages/myAccount/prevention/PreventionView';
import * as lightbox from '../../../home24/helpers/lightbox';

register('myaccount-profile', function() {
  new MainView({
    el: $('#myaccount-wrapper')
  });
});

/*
register bootstrap for
 */
register('myaccount-orders', function() {
  var $element = $('#reclamation-success-popup');

  if ($element.length > 0) {
    lightbox
      .setConfig({
        $dialog: $element,
        className: 'reclamation-success-popup'
      })
      .open();
  }

  new OrderListView({
    el: $('#myaccount-main')
  });
});

register('myaccount-prevention', function() {
  var $preventionPage = $('#prevention-page');

  if ($preventionPage.length > 0) {
    new PreventionView({
      el: $preventionPage,
      model: new PreventionModel()
    });
  }
});

register('wishlist', function() {
  new AddToCart({
    pageType: 'wishlist'
  });
});

register('reset-password', function() {
  new PasswordQualityView({
    el: $('.myaccount-login-reset')
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/myAccountBootstrap.js
 **/